





export const SuperAdminMenuList = [
    //Dashboard
    {
        title: 'Dashboard',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="fas fa-home"></i>,
       
    },    
    {
        title : "Client",
        classsChange: 'mm-collapse',
        // update:"New",
        iconStyle: <i className="fas fa-users" />,
        content:[
            {
                title:'Client List',
                to:'super-admin-client'
            },
           
        ],
    },

    {
        title : "users Category",
        classsChange: 'mm-collapse',
        // update:"New",
        iconStyle: <i className="fas fa-users" />,
        content:[
            // {
            //     title:'User Level',
            //     to:'user-level'
            // },
            // {
            //     title:'User category',
            //     to:'user-category'
            // },
            {
                title:'User Category Type',
                to:'user-category-type'
            },
            {
                title:'User Sub Category',
                to:'user-sub-category'
            },
           
        ],
    },
      {
        title : "admin Category",
        classsChange: 'mm-collapse',
        // update:"New",
        iconStyle: <i className="fas fa-users" />,
        content:[
            // {
            //     title:'User Level',
            //     to:'user-level'
            // },
            // {
            //     title:'User category',
            //     to:'user-category'
            // },
            {
                title:'User List',
                to:'admin-category-type'
            },
            
           
        ],
    },
   
    
]



export const AdminMenuList = [
    //Dashboard
    {
        title: 'Dashboard',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="fas fa-home"></i>,
       
    },  
    
    {
        title : "Manage Registration",
        classsChange: 'mm-collapse',
        // update:"New",
        iconStyle: <i className="fas fa-users" />,
        content:[
            {
                title:'Insititute List',
                to:'Organization'
            },
            {
                title:'Individual  List',
                to:'Individual'
            },
            
           
        ],
    },

    {
        title : "Manage Verification",
        classsChange: 'mm-collapse',
        // update:"New",
        iconStyle: <i className="fas fa-users" />,
        content:[
            {
                title:'Insititute  Verification List',
                to:'verified-insitute-user'
            },
            {
                title:'Individual Verification List',
                to:'verified-individual-user'
            },
            
           
        ],
    },
   
   
    
]